module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#group",
      toString: function () {
        return this.url;
      }
    }